import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Moment } from 'moment'

import hasFeature from 'modules/core/lib/hasFeature'

import type Employee from 'modules/employees/store/models/Employee'
import { type AllowanceIncidences } from 'modules/timeoff/store/collections/allowanceIncidences'
import type Allowance from 'modules/timeoff/store/models/Allowance'

import LegacyStatsCounter from './LegacyStatsCounter'
import NewStatsCounter from './NewStatsCounter'

interface Props {
  employee: Employee
  allowances: Allowance[]
  allowanceIncidences: AllowanceIncidences
  referenceDate: Moment
}

const List = ({ employee, allowances, allowanceIncidences, referenceDate }: Props) => (
  <Box gap="s32" paddingTop="s32">
    {allowances.map((allowance) => {
      if (hasFeature('dev_new_timeoff_counters')) {
        return <NewStatsCounter key={allowance.id} employee={employee} allowance={allowance} />
      }

      return (
        <LegacyStatsCounter
          key={allowance.id}
          employee={employee}
          allowance={allowance}
          allowanceIncidences={allowanceIncidences}
          originalReferenceDate={referenceDate}
        />
      )
    })}
  </Box>
)

export default List
